import React from 'react'
import '../../componentes/estilos/cargar.css'

const Cargar = () =>(
    <div className="loader"></div>
)

export default Cargar
